exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p{margin:0}p span{font-weight:700}", ""]);

// exports
